export const fundingModalDefaultCustomAmount = '$0.00'
